import { trim } from "lodash";
import sqlFormatter from "sql-formatter";
import yaml from "js-yaml";
import prettier from "prettier/standalone";
import prettierGraphql from "prettier/parser-graphql";

interface QueryFormatterMap {
  [syntax: string]: (queryText: string) => string;
}

const QueryFormatters: QueryFormatterMap = {
  sql: queryText => sqlFormatter.format(trim(queryText)),
  json: queryText => JSON.stringify(JSON.parse(queryText), null, 4),
  text: queryText => queryText,
  yaml: queryText => {
    return yaml.safeDump(yaml.safeLoad(queryText), {
      indent: 4,
      lineWidth: -1,
    });
  },
  graphql: queryText => {
    return prettier.format(queryText, {
      parser: "graphql",
      plugins: [prettierGraphql],
      
    });
  }
};

export function isFormatQueryAvailable(syntax: string) {
  return syntax in QueryFormatters;
}

export function formatQuery(queryText: string, syntax: string) {
  if (!isFormatQueryAvailable(syntax)) {
    return queryText;
  }
  const formatter = QueryFormatters[syntax];
  return formatter(queryText);
}
